import { ConfigContext } from "../../App";
import React,{ useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { SubscriptionService } from "../../models/subscription-service";
import parse from 'html-react-parser';
import PNSHeader from "../pnsheader/pnsheader";
import Spinner from "../spinner/spinner";
import { OMEGA_ENV } from "../../constants";
import OMEGA from "../../omega";
import ReactTooltip from 'react-tooltip';
import './pnsunsubscribeall.scss';

export default function PnsUnsubscribeAll() {

    const eventDefaultValue = {
        element: "PNS Unsubscribe All",
        action: "click",
        type: "Component",
        widget: {
            name: "pnsunsubscribe",
            type: "component"
        }
    }

    function omega_capture(element: any, widget_name: any, widget_type: any) {
        OMEGA.init().updateAndTrack("event", [{
            ...eventDefaultValue,
            element: element,
            widget: {
                name: widget_name,
                type: widget_type
            },
        }]);
    }

    const locales = useContext(ConfigContext).appConfig.languageData;
    const historyAPI = useHistory();
    const subscriptionService: SubscriptionService = SubscriptionService.init();
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') ReactTooltip.hide(); };
        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, []);

    function unSubscribeAll() {
        setLoading(true);
        subscriptionService.deleteSelfSubscription()
            .then(() => {
                subscriptionService.clearMyEventsContextCache();
                OMEGA.init().updateAndTrack('page', {
                    hierarchy: "home:manage-subscription:unsubscribe-all",
                    name: "PNS - Unsubscribe All- Adobe status",
                    url: encodeURIComponent(window.location.href),
                    type: "pns",
                    env: OMEGA_ENV
                });
                setLoading(false);
                redirect();
            }).catch((error: any) => {
                console.error('Error in pnsunsubscribe unsubscribe all:', error);
                omega_capture(
                    `Error in pnsunsubscribe unsubscribe all: ${error.message || error.toString()}`,
                    "pnsunsubscribe",
                    "error"
                );
                setLoading(false);
                setError(true);
            });
    }

    function redirect() {
        historyAPI.push({
            pathname: `/proactive-notifications/manage`,
            state: {
                tab: "product",
                page: "pns"
            }
        })
    }


    return (
        <div className="unsubscription-container">
            <PNSHeader></PNSHeader>
            <div className="container">
                <div className="unsubscribe-all">
                    <div className="title" role="heading" aria-level={2}>{locales.unsubscribe_all}</div>
                    <p>{locales.unsubscribe_all_message}</p>
                    <div aria-live="polite" aria-atomic="true">
                        {loading && <span>Loading unsubscribe all</span>}
                    </div>
                    <div className="buttons">
                        <button 
                            onClick={unSubscribeAll} 
                            className={`btn primary ${loading ? 'loading' : ''}`} 
                            disabled={loading}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    if (!loading) {
                                        unSubscribeAll();
                                    }
                                }
                            }}
                            aria-label={`${locales.sb_done}${loading ? ', loading' : ''}`}
                            tabIndex={0}
                        >
                            {locales.sb_done}{loading ? <Spinner isButton={true} /> : ''}
                        </button>
                        <button 
                            onClick={() => { redirect() }} 
                            className="btn"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    redirect();
                                }
                            }}
                            aria-label={`${locales.cancel_txt}, go back to previous page`}
                            tabIndex={0}
                        >
                            {locales.cancel_txt}
                        </button>
                    </div>
                    {error ? <div className="error-info" onClick={() => { historyAPI.push('/') }}>{parse(locales.api_error)}</div> : ""}
                </div>
            </div>
            <ReactTooltip clickable delayHide={200} />
        </div>
    );
}
